// This file makes use of the jenkins job variables set in index.html.

// We have a lot of exception case handling here to deal with the fact that we have two different environments
//    demo (aka labs) - customers who were beta users for our category api [LEGACY]
//    platform (aka v3) - new customers and migrated beta customers [STANDARD]

// Honestly though...don't ask why I didn't just make a bunch of default object configs.

export const STANDARD = 'standard';
export const LEGACY = 'legacy';
const TARGET = '';
// Probably should have named this APP_MODE with BETA + LATEST but it would affect the jenkins job.
export const API_MODE = (
  window.voicebaseEnv && window.voicebaseEnv.apiMode !== 'VOICEBASE_API_MODE_REPLACEME'
    ? window.voicebaseEnv.apiMode
    : STANDARD
);

const API_URL_DEFAULT = (
  API_MODE === STANDARD
    ? `https://apis${TARGET}.voicebase.com/v3`
    : `https://query-analytic${TARGET}.labs.voicebase.com`
);

const PLAYER_URL_DEFAULT = (
  API_MODE === STANDARD
    ? `https://player${TARGET}.voicebase.com/index.html`
    : `https://analyst-workbench${TARGET}.labs.voicebase.com/player/index.html`
);
// no target in player link - doesn't seem to have analog on QA

// API URL to query against
export const API_URL = (
  window.voicebaseEnv && window.voicebaseEnv.apiUrl !== 'VOICEBASE_API_REPLACEME'
    ? window.voicebaseEnv.apiUrl
    : API_URL_DEFAULT
);

// URL to load the player from
export const PLAYER_URL = (
  window.voicebaseEnv && window.voicebaseEnv.playerUrl !== 'VOICEBASE_PLAYER_REPLACEME'
    ? window.voicebaseEnv.playerUrl
    : PLAYER_URL_DEFAULT
);

// All demo (labs) bearerTokens are checked against production, so we need to pull media from there.
// For production environments, we can just use the normal API_URL.
export const MEDIA_API_URL = (
  API_MODE === STANDARD
    ? API_URL
    : 'https://apis.voicebase.com/v3'
);

export default {
  API_URL,
  API_MODE,
  PLAYER_URL,
  MEDIA_API_URL,
};
